import { Component, Input } from '@angular/core'

// Renders for any ServicePlanStepId the visibility-matrix engine reaches that has no
// real step component yet (story e8-1 AC9) — i.e. every step except 'planType' until
// future e8-2+ stories replace it. Intentionally a dead end: only a Back action, no
// Continue, since there is nothing real to validate or advance into yet. Only ever
// reachable by the servicePlan AAD test group (the whole route is feature-flagged).
@Component({
  selector: 'app-service-plan-step-placeholder',
  templateUrl: './step-placeholder.component.html',
  styleUrls: ['./step-placeholder.component.scss'],
  standalone: false,
})
export class StepPlaceholderComponent {
  @Input() titleKey: string = ''
}
